import { TaskType } from '@/shared/domain/taskTypes';
/**
 * Task types served by the specificai-vllm-inference subchart instead of
 * Triton. Kept as a Set so adding another vLLM task type stays a one-line
 * change rather than scattering equality checks across the codebase.
 */
export const VLLM_TASK_TYPES = new Set([TaskType.summarization, TaskType.contentGeneration]);

export const isVllmTaskType = (taskType) => VLLM_TASK_TYPES.has(taskType);

/**
 * Entity-recognition task types (NER + NER-with-relations). The
 * "Prediction strategy" knob (chunk aggregation / truncation) is
 * classification-only — the NER serving stack ignores it — so callers use
 * this to hide that control for entity-recognition tasks.
 */
export const NER_TASK_TYPES = new Set([TaskType.NER, TaskType.NER_WITH_RELATIONS]);

export const isNerTaskType = (taskType) => NER_TASK_TYPES.has(taskType);

/**
 * Label of the action that starts a training run (wizard header, task-page
 * Submit, Retrain modal). One constant so the wording stays the same on
 * every surface and the walkthrough copy can point at it by name.
 */
export const TRAIN_ACTION_LABEL = 'Finish & Create Model';

/**
 * Training status constants
 */
export const TRAINING_STATUSES = {
    COMPLETED: 'completed',
    CANCELED: 'canceled',
    FAILED: 'failed',
    WAITING: 'waiting',
    PREPARING: 'preparing',
    TRAINING: 'training',
    EVALUATING: 'evaluating',
    OPTIMIZING: 'optimizing',
    SELECTING: 'selecting',
    INITIALIZING: 'initializing',
    PAUSED: 'paused',
    LLM_AS_A_JUDGE: 'llm_as_a_judge',
};

export const EVALUATION_PHASE_TRAINING_STATUSES = [
    TRAINING_STATUSES.EVALUATING,
    TRAINING_STATUSES.LLM_AS_A_JUDGE,
];

export const isEvaluationPhaseTrainingStatus = (status) =>
    EVALUATION_PHASE_TRAINING_STATUSES.includes(String(status || '').toLowerCase());

/**
 * Training statuses that should hide the progress card
 */
export const FINAL_TRAINING_STATUSES = [
    TRAINING_STATUSES.COMPLETED,
    TRAINING_STATUSES.CANCELED,
    TRAINING_STATUSES.FAILED,
];

/**
 * Default training parameters
 */
export const getDefaultTrainingParams = () => ({
    DEFAULT_TRAIN_RATIO: 70,
    DEFAULT_VALIDATION_RATIO: 15,
    DEFAULT_METRIC_OPTIMIZATION: 'f_beta_score',
});

/**
 * Training parameter limits
 */
export const TRAINING_PARAM_LIMITS = {
    MIN_TRAIN_RATIO: 0,
    MAX_TRAIN_RATIO: 100,
    MIN_VALIDATION_RATIO: 0,
    MAX_VALIDATION_RATIO: 100,
}; 